var _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 192,
    viewBox: "0 0 252 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 72.5,
    rx: 21,
    ry: 21.5,
    fill: "#6E90FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5715 79.6842C38.4604 79.6842 38.4604 77.75 38.4604 77.75C38.4604 77.75 38.4604 75.8158 36.5715 75.8158C34.6826 75.8158 34.6826 76.6818 34.6826 77.75C34.6826 78.8182 34.6826 79.6842 36.5715 79.6842Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8413 75.2632C39.0001 75.2632 39.0001 73.0527 39.0001 73.0527C39.0001 73.0527 39.0001 70.8422 36.8413 70.8422C34.6826 70.8422 34.6826 71.8318 34.6826 73.0527C34.6826 74.2735 34.6826 75.2632 36.8413 75.2632Z",
    fill: "#9AB2FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4446 62C34.143 62 35.7621 63.6579 35.7621 66.4211V71.3947C35.7621 72.9158 35.2715 74.1019 34.3803 74.861C35.1873 75.4981 35.7621 76.4859 35.7621 77.4737C35.7621 80.7895 33.6033 83 30.3653 83H9.85733C8.50812 83 8.23828 82.7237 8.23828 81.3421V75.8158V74.1579V67.5263C8.23828 64.2105 10.397 62 13.6351 62H31.4446Z",
    fill: "#D9E2FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9047 76.921H16.3333C15.254 76.921 15.2539 77.1973 15.2539 77.75C15.2539 78.3026 15.7936 79.1315 19.0317 79.1315H28.2063C31.4444 79.1315 31.9841 78.3026 31.9841 77.75C31.9841 77.1973 31.9839 76.921 30.9047 76.921Z",
    fill: "#FFA175"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7941 63.6578H31.4449C33.0639 63.6578 34.1433 65.3157 34.1433 66.9736V70.842C34.1433 72.4999 33.0639 74.1578 31.4449 74.1578H15.7941C14.1751 74.1578 13.0957 72.4999 13.0957 70.842V66.9736C13.0957 65.3157 14.1751 63.6578 15.7941 63.6578Z",
    fill: "#819FFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.032 71.9474C20.8204 71.9474 22.2701 70.4628 22.2701 68.6316C22.2701 66.8003 20.8204 65.3158 19.032 65.3158C17.2437 65.3158 15.7939 66.8003 15.7939 68.6316C15.7939 70.4628 17.2437 71.9474 19.032 71.9474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.286 71.9474C31.0744 71.9474 32.5241 70.4628 32.5241 68.6316C32.5241 66.8003 31.0744 65.3158 29.286 65.3158C27.4977 65.3158 26.0479 66.8003 26.0479 68.6316C26.0479 70.4628 27.4977 71.9474 29.286 71.9474Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42893 79.6842C9.31782 79.6842 9.31782 78.8182 9.31782 77.75C9.31782 76.6818 9.31782 75.8158 7.42893 75.8158C5.54004 75.8158 5.54004 77.75 5.54004 77.75C5.54004 77.75 5.54004 79.6842 7.42893 79.6842Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15873 75.2632C9.31746 75.2632 9.31746 74.2735 9.31746 73.0527V73.0527C9.31746 71.8318 9.31746 70.8422 7.15873 70.8422C5 70.8422 5 73.0527 5 73.0527C5 73.0527 5 75.2632 7.15873 75.2632Z",
    fill: "#9AB2FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.998 131.866C251.998 135.88 250.35 139.508 247.693 142.112C247.677 142.128 247.66 142.144 247.643 142.161C247.425 142.372 247.2 142.577 246.969 142.774C246.513 143.165 246.032 143.527 245.529 143.858C243.269 145.346 240.562 146.211 237.653 146.211C234.745 146.211 232.038 145.346 229.777 143.858C229.275 143.527 228.794 143.165 228.338 142.774C228.106 142.577 227.882 142.372 227.664 142.161C227.647 142.144 227.63 142.128 227.614 142.112C224.957 139.508 223.309 135.88 223.309 131.866C223.309 123.944 229.731 117.521 237.653 117.521C245.576 117.521 251.998 123.944 251.998 131.866Z",
    fill: "#527BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.643 142.16C247.425 142.372 247.2 142.576 246.969 142.774C246.513 143.165 246.032 143.526 245.529 143.857C243.269 145.345 240.562 146.211 237.654 146.211C234.745 146.211 232.038 145.345 229.778 143.857C229.275 143.526 228.794 143.165 228.338 142.774C228.107 142.576 227.882 142.372 227.664 142.16C228.205 140.485 229.527 139.127 231.271 138.577L235.517 137.236V136.536C234.984 136.22 234.509 135.858 234.117 135.593C233.387 135.101 232.896 134.33 232.751 133.462L232.525 132.107C231.816 132.107 231.242 131.534 231.242 130.825C231.242 130.298 231.559 129.846 232.013 129.649C231.616 128.719 231.326 127.734 231.151 126.724C231.04 126.084 230.977 125.409 231.165 124.791C231.353 124.174 231.85 123.633 232.437 123.622L232.514 123.627C232.884 123.049 233.462 122.668 234.069 122.448C234.677 122.228 235.318 122.153 235.953 122.08C236.201 122.051 236.451 122.022 236.701 121.997C237.854 121.886 239.11 121.859 240.29 122.188C241.47 122.516 242.609 123.253 243.21 124.427C243.687 125.359 243.784 126.483 243.664 127.547C243.584 128.253 243.415 128.94 243.217 129.618C243.712 129.795 244.065 130.268 244.065 130.825C244.065 131.534 243.492 132.107 242.782 132.107L242.556 133.462C242.411 134.33 241.92 135.101 241.191 135.593C240.798 135.858 240.323 136.22 239.791 136.536V137.236L244.036 138.577C245.781 139.127 247.103 140.485 247.644 142.16H247.643Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.889 151.263C217.488 150.357 217.158 149.369 216.87 148.371C215.985 145.283 215.584 142.082 215.584 138.871V116.486C215.584 114.592 214.051 113.058 212.157 113.058H84.3567C81.5268 113.058 79.2217 115.354 79.2217 118.194V136.802C79.2217 139.633 81.5165 141.938 84.3567 141.938H195.713C199.016 141.938 202.227 143.019 204.861 145.015C208.669 147.897 213.32 150.697 216.839 152.323C217.498 152.632 218.177 151.952 217.879 151.283L217.889 151.263Z",
    fill: "#6E90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4976 190.604C46.899 189.698 47.2283 188.71 47.5164 187.712C48.4014 184.624 48.8027 181.423 48.8027 178.212V155.827C48.8027 153.933 50.336 152.399 52.2295 152.399H180.03C182.86 152.399 185.165 154.695 185.165 157.535V176.143C185.165 178.974 182.87 181.279 180.03 181.279H68.674C65.3707 181.279 62.16 182.36 59.5256 184.356C55.7181 187.238 51.0667 190.038 47.5473 191.664C46.8887 191.973 46.2095 191.293 46.5079 190.624L46.4976 190.604Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.496 107.418C46.8216 106.683 47.0887 105.881 47.3224 105.072C48.0403 102.567 48.3658 99.9708 48.3658 97.3661V48.2525C48.3658 46.7164 49.6095 45.4725 51.1454 45.4725H185.786C188.09 45.4725 189.951 47.3342 189.951 49.6383V95.6797C189.951 97.9755 188.09 99.8455 185.786 99.8455H64.4759C61.7964 99.8455 59.1921 100.722 57.0552 102.342C53.9668 104.679 50.1938 106.95 47.3391 108.269C46.8049 108.52 46.254 107.969 46.496 107.426V107.418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.496 107.418C46.8215 106.683 47.0887 105.881 47.3224 105.072C48.0403 102.567 48.3658 99.9708 48.3658 97.3661V48.2525C48.3658 46.7164 49.6095 45.4725 51.1454 45.4725H185.786C188.09 45.4725 189.951 47.3342 189.951 49.6383V95.6797C189.951 97.9755 188.09 99.8455 185.786 99.8455H64.4759C61.7964 99.8455 59.1921 100.722 57.0552 102.342C53.9668 104.679 50.1938 106.95 47.3391 108.269C46.8049 108.52 46.2539 107.969 46.496 107.426V107.418Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_68_1824)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 189.906,
    cy: 56.6166,
    r: 36.6166,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_68_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.682 56.0246C207.687 61.548 205.474 66.8454 201.532 70.7436L190.958 81.1986C190.617 81.5358 190.169 81.7032 189.723 81.6998C189.286 81.6963 188.852 81.53 188.517 81.2009L177.931 70.7563C173.985 66.8638 171.767 61.5675 171.767 56.0441V40.8801H175.183C179.65 40.8801 183.949 39.1942 187.21 36.163L189.684 33.8646V33.813L189.711 33.8383L189.724 33.8257L189.739 33.8119V33.8635L192.216 36.1595C195.48 39.1873 199.781 40.8686 204.248 40.8629L207.664 40.8595L207.682 56.0235V56.0246Z",
    fill: "#00D047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.239 45.9692L199.855 45.9715C196.739 45.975 193.738 44.8017 191.461 42.6903L189.735 41.0881V41.0526L189.715 41.0709L189.695 41.0526V41.0881L187.97 42.6914C185.695 44.8063 182.696 45.9818 179.579 45.9818H177.195V56.5606C177.195 60.4141 178.743 64.1082 181.497 66.824L188.882 74.1102C189.353 74.5746 190.113 74.5746 190.585 74.1102L197.962 66.816C200.712 64.0968 202.255 60.4004 202.252 56.5469L202.24 45.9681L202.239 45.9692Z",
    fill: "#27967A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.792 54.0008L197.566 51.5889C197.334 51.1325 196.698 51.0809 196.394 51.4937C196.394 51.4937 189.733 60.405 189.545 60.4233C189.357 60.4417 186.164 57.6341 186.164 57.6341C185.967 57.4529 185.68 57.4025 185.432 57.5045L183.772 58.1904C183.301 58.3853 183.199 59.0023 183.583 59.3361L188.556 63.6656L189.435 64.4546C189.723 64.7138 190.17 64.6851 190.422 64.3915L198.702 54.7532C198.882 54.5433 198.918 54.2474 198.794 54.0008H198.792Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_1824",
    x: 29.6826,
    y: 67.8422,
    width: 12.3174,
    height: 16.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_1824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_68_1824",
    x: 3.23828,
    y: 59,
    width: 35.5234,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_1824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_68_1824",
    x: 15.2539,
    y: 76.921,
    width: 16.7305,
    height: 2.21057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_68_1824"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_68_1824",
    x: 13.0957,
    y: 63.6578,
    width: 21.0479,
    height: 10.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_68_1824"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_68_1824",
    x: 7.79395,
    y: 57.3158,
    width: 32.7305,
    height: 22.6316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_1824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_68_1824",
    x: 0,
    y: 67.8422,
    width: 12.3174,
    height: 16.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_1824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_68_1824",
    x: 133.289,
    y: 0,
    width: 113.233,
    height: 113.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_1824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6897,
    height: 28.6897,
    fill: "white",
    transform: "translate(223.309 117.521)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_68_1824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9151,
    height: 47.8867,
    fill: "white",
    transform: "translate(171.767 33.8135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityImage);
export default __webpack_public_path__ + "static/media/security-image.12bf7ca95c30dbb8274e125a84132aeb.svg";
export { ForwardRef as ReactComponent };